import React, { useState, useEffect, useContext } from 'react';

import Container from '@mui/material/Container';
import { Box } from '@mui/system';
import {
  TextField,
  Typography,
  Select,
  MenuItem,
  Input,
  Button,
  TableCell,
  FormControl,
  InputLabel,
  FormHelperText,
  Slide,
  Alert,
  AlertTitle,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Table,
  TableRow,
  CenterCell,
  TableHeader,
  TableWrapper,
  FirstRowHeader,
} from '../../../assets/styles/sharedStyles/sharedStyles';

import { api } from 'api/api';
import axios from 'axios';
import { GlobalContext } from 'context/GobalState';
import DownloadIcon from '@mui/icons-material/Download';
import { FileNameCell } from './ImportView.styles';
import TagModal from 'components/atoms/Modal/TagModal/TagModal';
import Modal from 'components/atoms/Modal/Modal';
import Pagination from '../Pagination/Pagination';
import { SortBtn, PaginationRow } from '../../molecules/TableComponent/TableComponent.styles';
import { useErrorHandler } from 'react-error-boundary';

const ImportView = () => {
  const { authToken, campaign, skill } = useContext(GlobalContext);

  const handleError = useErrorHandler();

  const [selectedFile, setSelectedFile] = useState(null);
  const [skillList, setSkillList] = useState([]);
  const [skillName, setSkillName] = useState('');
  const [tagName, setTagName] = useState('');
  const [description, setDescription] = useState('');
  const [skillError, setSkillError] = useState(false);
  const [campError, setCampError] = useState(false);
  const [loadHistory, setLoadHistory] = useState([]);
  const [disableSend, setDisableSend] = useState(true);
  const [isModalActive, setModalActive] = useState(false);
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);

  const onFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    setDisableSend(false);
  };
  const handleChangeSkill = (event) => {
    setTagName(event.target.value);
  };
  const handleChangeDes = (event) => {
    setDescription(event.target.value);
  };

  const getTags = () => {
    if (authToken && skill) {
      axios
        .get(`${api}data/tags_load/`, {
          headers: {
            Authorization: `token ${authToken}`,
          },
          params: { skill: skill },
        })
        .then(({ data }) => {
          setSkillList(data);
        })
        .catch((error) => {
          console.log(error);
          handleError(error);
        });
    }
  };

  const onSubmit = () => {
    const formData = new FormData();

    formData.append('skill_name', skill);
    formData.append('campaign_name', campaign);
    formData.append('file', selectedFile, selectedFile.name);
    formData.append('tag_name', tagName);
    formData.append('description', description);
    if (tagName === '') {
      setSkillError(true);
    } else {
      setSkillError(false);
    }
    if (campaign === 'All Campaign') {
      setAlert(true);
    } else {
      setAlert(false);
    }

    if (skill && campaign !== 'All Campaign' && selectedFile && tagName) {
      setDisableSend(true);

      axios
        .post(`${api}data/load_campaign/`, formData, {
          headers: {
            Authorization: `token ${authToken}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            setSelectedFile();
            setTagName('');
            setDescription('');
            loadHistoryTable();
            setDisableSend(true);
            setMessage(response.data);
            setOpenDialog(true);
          }
        })
        .catch((error) => {
          console.log(error);
          handleError(error);
        });
    }
  };
  const loadHistoryTable = () => {
    axios
      .get(`${api}data/load_campaign_history/`, {
        headers: {
          Authorization: `token ${authToken}`,
        },
        params: {
          skill: skill,
          rows_per_page: rowsPerPage,
          page_num: page + 1,
        },
      })
      .then(({ data }) => {
        setLoadHistory(data.data);
        setTotalRows(data.count);
      })
      .catch((error) => {
        console.log(error);
        handleError(error);
      });
  };
  const downloadFile = (historyID, filename) => {
    axios
      .get(`${api}data/load_campaign_history/${historyID}/download/`, {
        headers: {
          Authorization: `token ${authToken}`,
        },
        params: {
          skill: skill,
        },
        responseType: 'blob',
      })
      .then((response) => {
        const href = URL.createObjectURL(response.data);

        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', `${filename}.csv`);
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      })
      .catch((error) => {
        console.log(error);
        handleError(error);
      });
  };
  useEffect(() => {
    loadHistoryTable();
    getTags();
    // eslint-disable-next-line
  }, [authToken, skill, rowsPerPage, page]);
  useEffect(() => {
    if (tagName === 'MANAGE TAGS') {
      setModalActive(true);
    }
  }, [tagName]);
  const handleClose = () => {
    setOpenDialog(false);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <Container>
      <Modal isActive={isModalActive} setActive={() => setModalActive(false)} version>
        <TagModal
          setActive={() => setModalActive(false)}
          setTagName={setTagName}
          getTags={getTags}
          skillList={skillList}
        />
      </Modal>
      <Dialog open={openDialog} onClose={handleClose}>
        <DialogTitle>{'Import records summary'}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography>{message.success_message}</Typography> <Typography>{message.error_message}</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {alert ? (
        <Slide direction="down" in={!!alert} mountOnEnter unmountOnExit>
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            <p>Choose Campaign!</p>
          </Alert>
        </Slide>
      ) : (
        ''
      )}
      <h2>Import</h2>
      <Box
        sx={{
          width: '50%',
          minHeight: '200px',
          height: 'auto',
          border: '1px solid #dadce0',
          borderRadius: '10px',
          m: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            mt: 4,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <FormControl error={campError}>
              <TextField
                error={campError}
                id="outlined-name"
                label="Description"
                value={description}
                onChange={handleChangeDes}
                size="small"
              />
              <FormHelperText>{campError && 'Required'}</FormHelperText>
            </FormControl>
            <FormControl size="small" sx={{ ml: 2, mb: 2 }} error={skillError}>
              <InputLabel id="demo-simple-select-label">Tag</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={tagName}
                label="Tag"
                onChange={handleChangeSkill}
                sx={{ width: '150px' }}
                MenuProps={{
                  style: {
                    maxHeight: 700,
                  },
                }}
              >
                {skillList?.map((option, index) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{skillError && 'Required'}</FormHelperText>
            </FormControl>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              height: '40px',
              mb: 2,
            }}
          >
            <label htmlFor="contained-button-file">
              <input
                style={{ display: 'none' }}
                accept=".csv"
                id="contained-button-file"
                multiple
                type="file"
                onChange={onFileChange}
              />
              <Button variant="contained" component="span" sx={{ mr: 2 }}>
                Choose a file
              </Button>
            </label>
            <Button variant="contained" component="span" onClick={onSubmit} disabled={disableSend}>
              Import records
            </Button>
          </Box>
          <Typography sx={{ ml: '6px' }}>{selectedFile?.name ? selectedFile?.name : 'No file selected'}</Typography>
        </Box>
      </Box>
      <Box sx={{ mt: 5, pb: 5 }}>
        <h3>Import History</h3>
        <TableWrapper>
          <Table>
            <TableHeader>
              <FirstRowHeader>
                <th colSpan={1}>ID</th>
                <th colSpan={1}>User</th>
                <th colSpan={1}>Filename</th>
                <th colSpan={1}>Tag</th>
                <th colSpan={1}>Campaign</th>
                <th colSpan={1}>Import time</th>
              </FirstRowHeader>
            </TableHeader>
            <tbody>
              {loadHistory.map((item) => (
                <TableRow key={item.name}>
                  <CenterCell>{item.history_id}</CenterCell>
                  <CenterCell>{item.user}</CenterCell>
                  <FileNameCell>
                    <p className="tekst">{item.filename}</p>
                    <DownloadIcon
                      color="primary"
                      className="icon"
                      onClick={() => downloadFile(item.history_id, item.filename)}
                    />
                  </FileNameCell>
                  <CenterCell>{item.tag}</CenterCell>
                  <CenterCell>{item.campaign}</CenterCell>
                  <CenterCell>
                    {item.timestamp?.slice(0, 10)} {item.timestamp?.slice(11, 16)}
                  </CenterCell>
                </TableRow>
              ))}
              <PaginationRow>
                <td colSpan={6}>
                  <Pagination
                    totalRows={totalRows}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                  />
                </td>
              </PaginationRow>
            </tbody>
          </Table>
        </TableWrapper>
      </Box>
    </Container>
  );
};

export default ImportView;
